
// FILE: src/helper/cart.js
class CartHelper {
    
    static loadDefaultProperties() {
        // Default labels
        this.cartProperties.labels.header = this.cartProperties.labels.header || "Dados do pedido";
        this.cartProperties.labels.emptyCart = this.cartProperties.labels.emptyCart || "Carrinho vazio. Adicione itens para prosseguir";
        this.cartProperties.labels.footerButton = this.cartProperties.labels.footerButton || "Finalizar Pedido";
    
        // Default cart properties
        this.cartProperties.cart = [];
    
        // Default cart visibility
        this.showCartContent = false;
    }
    
    static getFieldName(name) {
        return this.cartProperties.itemFields[name];
    }
    
    static increaseItemCount(item, getFieldName) {
        if(item['IDTIPOCOMPPROD'] != 'C') {
            item[getFieldName('quantity')]++;
        } else {
            item[getFieldName('quantity')]++;
        }
    }
    
    static generateItemHash() {
        return Date.now();
    }
}

export default CartHelper;

// FILE: src/service/CartService.js
function CartService(ScreenService, templateManager) {

	/**
	 * Reload cart passing the cart widget and a cart itens array
	 * @param {Widget} cartWidget Not much to say, just the cart widget
	 * @param {Array} cart Cart items array
	*/
	this.reload = function(cartWidget, cart) {
		cartWidget.cartProperties.cart = cart;
    };

	/**
	 * Get selected product when clicking on the personalize button
	 * @param {Widget} cartWidget Not much to say, just the cart widget
	*/
    this.getSelectedProduct = function(cartWidget) {
    	return cartWidget.selectedProduct;
    };

}
Configuration(function(ContextRegister) {
	ContextRegister.register('CartService', CartService);
});


// FILE: src/controller/CartController.js
function CartController($scope, ScreenService, $rootScope, ApplicationContext, maskEngine) {
    
    const widget = $scope.widget;

    /* Scope methods */
    $scope.$watchCollection('widget.cartProperties.cart', (newCart, oldCart) => {
        if ((newCart.length > oldCart.length) && (newCart.length !== 0)) {
            const idx = newCart.length - 1;

            if (!newCart[idx].personalizations) {
                newCart[idx].personalizations = {};
                newCart[idx].personalizations.observations = [];
                newCart[idx].personalizations.ingredients = [];
            }

            /* Get the product personalizations */
            _handleProductPersonalizations(newCart[idx]);

            newCart[idx].itemHash = CartHelper.generateItemHash();

            if (newCart[idx][_getFieldName('customObservation')] !== undefined) {
                newCart[idx].personalizations.customObservation = newCart[idx][_getFieldName('customObservation')];
            }
        }
    });

    $scope.getFieldName = CartHelper.getFieldName.bind(widget);

    /* Private methods */
    const _getFieldName = $scope.getFieldName;

    /* Controller methods */
    this.loadDefaultProperties = CartHelper.loadDefaultProperties.bind(widget);
    this.increaseItemCount = CartHelper.increaseItemCount;

    const _handleProductPersonalizations = (currentProduct) => {
        currentProduct.selectedPage = currentProduct.selectedPage ? currentProduct.selectedPage : {};
        let selectedPersonalizations = currentProduct.selectedPage ? currentProduct.selectedPage.selectItems : null;
        let selectedPersonalizationsOrdinary = currentProduct.ordinaryObservations ? currentProduct.ordinaryObservations : null;
        let selectedCombo = !!currentProduct.PROMOPRODS ? currentProduct.PROMOPRODS : null;
        
        // Combo product
        if (!!selectedCombo && !!currentProduct.isCombo) {
            // setup those fields
            currentProduct.personalizations.observations = [];
            currentProduct.personalizations.ingredients = [];
            const observationCode = _getFieldName('observationCode');
            const observationName = _getFieldName('observationName');
            const personalizationType = _getFieldName('personalizationType');
                
            selectedCombo.forEach(personalization => {
                const data = {
                    [observationCode]: personalization[observationCode],
                    [observationName]: personalization[observationName],
                    [personalizationType]: personalization[personalizationType],
                    selected: true
                };
                
                if (data[personalizationType] === 'A') {
                    // Set temporary quantity
                    data[_getFieldName('quantity')] = !!personalization.qtty ? personalization.qtty : 1;
                    if (currentProduct.personalizations.ingredients) {
                        currentProduct.personalizations.ingredients.push(data);
                    }
                }
            });
            
            if (selectedPersonalizationsOrdinary) {
                selectedPersonalizationsOrdinary.forEach(personalization => {
                    let data = {
                        [observationCode]: personalization[observationCode],
                        [observationName]: personalization[observationName],
                        [personalizationType]: personalization[personalizationType],
                        selected: true
                    };
                    
                    if (data[personalizationType] !== 'A') {
                        if (currentProduct.personalizations.observations) {
                            currentProduct.personalizations.observations.push(data);
                        }
                    }
                });
            }
        } else if (selectedPersonalizationsOrdinary.length > 0  && !currentProduct.isCombo && !selectedPersonalizations) {
            currentProduct.personalizations.observations = [];
            currentProduct.personalizations.ingredients = [];
            selectedPersonalizationsOrdinary.forEach(personalization => {
                const observationCode = _getFieldName('observationCode');
                const observationName = _getFieldName('observationName');
                const personalizationType = _getFieldName('personalizationType');
    
                const data = {
                    [observationCode]: personalization[observationCode],
                    [observationName]: personalization[observationName],
                    [personalizationType]: personalization[personalizationType],
                    selected: true
                };
    
                if (data[personalizationType] === 'A') {
                    // Set temporary quantity
                    data[_getFieldName('quantity')] = 1;
                    if (currentProduct.personalizations.ingredients) {
                        currentProduct.personalizations.ingredients.push(data);
                    }
                } else {
                    if (currentProduct.personalizations.observations) {
                        currentProduct.personalizations.observations.push(data);
                    }
                }
            });
        } else {
            currentProduct.personalizations.observations = [];
            currentProduct.personalizations.ingredients = [];
            
            const observationCode = _getFieldName('observationCode');
            const observationName = _getFieldName('observationName');
            const personalizationType = _getFieldName('personalizationType');
            
            if (selectedPersonalizations) {
            
                _toUnique(selectedPersonalizations);
                
                selectedPersonalizations.forEach(personalization => {
                    let data = {
                        [observationCode]: personalization[observationCode],
                        [observationName]: personalization[observationName],
                        [personalizationType]: personalization[personalizationType],
                        selected: true
                    };
        
                    if (data[personalizationType] === 'A') {
                        // Set temporary quantity
                        data[_getFieldName('quantity')] = !!personalization.qtty ? personalization.qtty : 1;
                        if (currentProduct.personalizations.ingredients) {
                            currentProduct.personalizations.ingredients.push(data);
                        }
                    }
                });
            }
            
            if (selectedPersonalizationsOrdinary) {
                selectedPersonalizationsOrdinary.forEach(personalization => {
                    let data = {
                        [observationCode]: personalization[observationCode],
                        [observationName]: personalization[observationName],
                        [personalizationType]: personalization[personalizationType],
                        selected: true
                    };
                    
                    if (data[personalizationType] !== 'A') {
                        if (currentProduct.personalizations.observations) {
                            currentProduct.personalizations.observations.push(data);
                        }
                    }
                });
            }
        }
    };
    
    /* To Unique I dont know how it work, but it works (lol) */
    const _toUnique = arr => { //array,placeholder,placeholder
        let b = arr.length - 1;
        let c;
        while (b > 0) {
            c = b - 1;
            while (c >= 0) {
                if (arr[b].CODIGOOCORRENCIA === arr[c].CODIGOOCORRENCIA) {
                    arr.splice(c, 1);
                    b = arr.length - 1;
                }
                c--;
            }
            b--;
        }
    }

    this.decreaseItemCount = (item) => {
        if (item[_getFieldName('quantity')] > 0) {
            if (item[_getFieldName('quantity')] === 1) {
                this.removeItemFromCart(item);
            } else {
                item[_getFieldName('quantity')]--;
            }
        }
    };
    
    this.recalculatePizza = (item) => { 
      item[_getFieldName('quantity')]--;
      let qtty  = item.qtty;
      item.PRICE = item.realPrice * qtty + item.optionsFullPrice;
	  item.total = item.PRICE;  
    };

    this.removeItemFromCart = (item) => {
        this.removeCartItem(item.itemHash).then(() => {
            if (widget.cartProperties.events.onRemoveCartItem) {
                $rootScope.$eval(widget.cartProperties.events.onRemoveCartItem, ApplicationContext);
            }
        }).catch((err) => {
            ScreenService.showMessage('Erro ao remover item do carrinho.');
        });
    };

    this.removeCartItem = (cartItemHash) => {
        let success = false;

        widget.cartProperties.cart.some((item, index) => {
            if (item['itemHash'] === cartItemHash) {
                widget.cartProperties.cart.splice(index, 1);
                success = true;
            }
        });

        let promise;
        if(success) promise = Promise.resolve();
        else promise = Promise.reject();
    	return promise;
    };

    this.finishOrder = () => {
        $rootScope.$eval(widget.cartProperties.events.onFinishOrder, ApplicationContext);
    };

    this.toggleObservation = (titleIndex, isCombo) => {
        if (isCombo) {
            let iconProduct = $(document).find('.combo-icon')[titleIndex];
            let productInfo = $(document).find('.combo-info')[titleIndex];
            $(iconProduct).toggleClass('rotated');
            $(productInfo).slideToggle("fast");
            $(productInfo).toggleClass("display-block");
        } else {
            let iconProduct = $(document).find('span.icon-title')[titleIndex];
            let productInfo = $(document).find('div.product-info-accordion')[titleIndex];
            $(iconProduct).toggleClass('rotated');
            $(productInfo).slideToggle("fast");
            $(productInfo).toggleClass("display-block");
        }
    };

    this.filterObservation = (observation) => {
        return observation.selected;
    };

    this.filterIngredient = (ingredient) => {
        return ingredient[_getFieldName('quantity')] > 0;
    };

    this.showCollapse = (item) => {
        if (item.isCombo || item.personalizations) {
            let hasCustomObservation = !!item.personalizations.customObservation;
            let hasSelectedObservations = false;
            let hasSelectedIngredients = false;
            let personalizations = item.personalizations;

            if(personalizations.observations !== undefined) {
                hasSelectedObservations = personalizations.observations.some(observation => observation.selected);            
            }
            if(personalizations.observations !== undefined) {
                hasSelectedIngredients = personalizations.ingredients.some(ingredient => ingredient.selected);
            }
            return hasSelectedObservations || hasSelectedIngredients || hasCustomObservation;
        } else {
            return false;
        }
    };

    this.checkProduct = item => {
        return item['IDTIPOCOMPPROD'] == 'C';
    };
    
    this.checkSmartProd = item => {
        return item['IDTIPOCOMPPROD'] == '3' || item['IDTIPOCOMPPROD'] == '4'; 
    }
    
    this.showAddItemsLabel = itemsAdd => {
        if(!!itemsAdd) {
            return itemsAdd.length > 0;
        } else return false;
    };
    
    this.showAddItemsComboLabel = itemsCombo => {
        return !!itemsCombo && itemsCombo.length > 0;
    };
    
    const _filterObservations = (observations) => {
        if (observations) {
            return observations.filter(observation => observation.selected);
        }
    };

    this.showPersonalizationsLabel = (personalizations) => {
        if (personalizations) {
            return _filterObservations(personalizations).length > 0;
        } else {
            return false;
        }
    };

    this.showComboLabel = (item) => {
        return item.isCombo;
    };

    this.getMaskedPrice = () => {
        let totalPrice = this.getTotalPrice();
		let formattedValue;

        if (!widget.cartProperties.showProductCents) {
			formattedValue = `R$ ${totalPrice.toFixed(0)}`;
		} else {
// 			formattedValue = maskEngine.currencyFormat(totalPrice);
			formattedValue = `R$ ${totalPrice.toFixed(2).toMoney()}`;
		}
		
		return formattedValue;
    };
    
    // if we make a price per product span then will use this code otherwise is completely wasted
    /*this.getMaskedProductPrice = item => {
        let totalPrice = this.getTotalPrice();
		let formattedValue;

        if (!widget.cartProperties.showProductCents) {
			formattedValue = `R$ ${totalPrice.toFixed(0)}`;
		} else {
// 			formattedValue = maskEngine.currencyFormat(totalPrice);
			formattedValue = `R$ ${totalPrice.toFixed(2).toMoney()}`;
		}
		
		return formattedValue;
    };*/
    
    this.getTotalPrice = () => {
		let totalPrice = 0;
		widget.cartProperties.cart.forEach(cartItem => {
			if (cartItem.IDTIPOCOMPPROD === 'C'){
			    totalPrice += _calculateCombinedProducts(cartItem);
			} else if (cartItem.isCombo) {
				totalPrice += this.calculateComboPrice(cartItem);
            } else if (cartItem[_getFieldName('promoProds')] ? cartItem[_getFieldName('promoProds')].length : false) {
                if(cartItem.IDTIPOCOMPPROD == '4') {
                    totalPrice = !!cartItem.total ? cartItem.PRICE * cartItem.qtty : 0; 
    
                    cartItem[_getFieldName('promoProds')].forEach(promoItem => {
        				totalPrice += parseFloat(promoItem[_getFieldName('price')]);
                    });
                    
                } else {
            //         totalPrice = !!cartItem.total ? cartItem.total * cartItem.qtty : 0; 
    
            //         cartItem[_getFieldName('promoProds')].forEach(promoItem => {
        				// totalPrice += parseFloat(promoItem[_getFieldName('price')]);
            //         });
                }
		    } else {
				totalPrice += cartItem.PRICE * cartItem.qtty;
                
                if (cartItem.selectedPage.selectItems) {
                    cartItem.selectedPage.selectItems.forEach(ingredient => {
                        if (ingredient.IDCONTROLAOBS === 'A') {
                            
                            if(!ingredient.qtty)
                                ingredient.qtty = 1;
                            
                            totalPrice += ((ingredient.PRICE * ingredient.qtty) * cartItem.qtty);                
                        }
                    });
                }
			}
		});
		return totalPrice;
	};
	
	const _calculateCombinedProducts = combined => {
	    let qtty  = combined.qtty;
	    let total = combined.realPrice * qtty;
	    
	    combined.SELECTION.forEach(product => {
	       if(!!product.MARKEDOBS) {
	           product.MARKEDOBS.forEach(add => {
    	           if (add.IDCONTROLAOBS == 'A') {
    	               total += add.slicePrice * qtty;
    	           }
    	       });
    	   }
	    });
	    
	    return total;
	};

	this.calculateComboPrice = (combo) => {
        let totalComboPrice = 0;
        if (combo.PRICE > 0){
            totalComboPrice = combo.PRICE;
            combo.comboCart.forEach(comboItem => {
                totalComboPrice += comboItem[_getFieldName('quantity')] * parseFloat(comboItem[_getFieldName('price')]);
            });
        } else {
            combo.PROMOPRODS.forEach(comboItem => {
                totalComboPrice += comboItem[_getFieldName('quantity')] * parseFloat(comboItem[_getFieldName('price')]);
            });
        }

        return totalComboPrice * combo[_getFieldName('quantity')];
	};

	this.personalizeProduct = (item) => {
		widget.selectedProduct = item;
        $rootScope.$eval(widget.cartProperties.events.onEditProduct, ApplicationContext);
    };

    const _handleItemFields = (itemFields) => {
        if (!itemFields.code) {
            _showRequiredFieldMessage('code');
        } else if (!itemFields.quantity) {
            _showRequiredFieldMessage('quantity');
        } else if (!itemFields.name) {
            _showRequiredFieldMessage('name');
        } else if (!itemFields.price) {
            _showRequiredFieldMessage('price');
        }
    };

    const _showRequiredFieldMessage = (fieldName) => {
        ScreenService.showMessage(
            `Propriedade "${fieldName}" obrigatória para o componente odh-cart. 
            <p>Confira a documentação do componente para prosseguir <a href="http://code.zeedhi.com/odhen-components/odh-cart/tree/master" target="_blank">aqui</a>.</p>`
        );   
    };

    this.hasCustomObservation = (item) => {
        let hasCustomObservation;
        if (item.personalizations) {
            hasCustomObservation = item.personalizations.customObservation;
        } else {
            hasCustomObservation = false;
        }
        return hasCustomObservation;
    };

    this.toggleCartContent = () => {
        widget.showCartContent = !widget.showCartContent;
    };

    this.getCartContentDisplay = () => {
        let display;
        
        let iosMode = (ApplicationContext.Utilities.systemPlatform == 'ios');
        
        if (screen.width <= 767 || iosMode) {
            display = widget.showCartContent ? 'block' : 'none';
        } else {
            display = 'block';
        }
        return display;
    };

    /* Handle item field properties */
    _handleItemFields(widget.cartProperties.itemFields);
}

/* Define CartController on window to be used on ng-controller
  (this was the best solution since we're using UMD and Angular 1.2 from Zeedhi) */
if (typeof (window) !== 'undefined') window.CartController = CartController;